import React, { useMemo } from 'react';

/** Gestructureerde parse (opleiding, ervaring) — geen aparte AI-samenvatting; die overlapt met systeem-CV/motivatie in het portaal. */
const AiParsedBlocks: React.FC<{ ai: Record<string, unknown> | null | undefined }> = ({ ai }) => {
  const blocks = useMemo(() => {
    if (!ai || typeof ai !== 'object') return [];
    const out: { title: string; body: string }[] = [];
    const edu = ai.education;
    if (Array.isArray(edu) && edu.length) {
      out.push({
        title: 'Opleiding',
        body: edu
          .map((e: any) => (typeof e === 'string' ? e : [e?.degree, e?.institution, e?.year].filter(Boolean).join(' — ')))
          .filter(Boolean)
          .join('\n'),
      });
    }
    const exp = ai.experience || ai.work_history;
    if (Array.isArray(exp) && exp.length) {
      out.push({
        title: 'Ervaring',
        body: exp
          .map((e: any) =>
            typeof e === 'string' ? e : [e?.title, e?.company, e?.duration, e?.description].filter(Boolean).join(' — '),
          )
          .filter(Boolean)
          .join('\n\n'),
      });
    }
    return out;
  }, [ai]);

  if (!blocks.length) return null;
  return (
    <div className="space-y-3">
      {blocks.map((b) => (
        <div key={b.title} className="rounded-xl border border-slate-100 bg-white p-3 shadow-sm">
          <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400">{b.title}</p>
          <p className="mt-1 whitespace-pre-wrap text-sm leading-relaxed text-slate-700">{b.body}</p>
        </div>
      ))}
    </div>
  );
};

export default AiParsedBlocks;
